import { render, staticRenderFns } from "./student_register.vue?vue&type=template&id=8381b79a&"
import script from "./student_register.vue?vue&type=script&lang=js&"
export * from "./student_register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports